// tienda/CoverageList.jsx
// Searchable list of Lima districts with a "contact us" fallback.

import React, { useState, useMemo } from "react";
import { Search, X } from "lucide-react";
import { brand, WA_HREF } from "../shared/brand";

const ALL_DISTRICTS = [
  "Ancón","Ate","Barranco","Bellavista","Breña","Carabayllo","Carmen de la Legua",
  "Cercado de Lima","Chorrillos","Comas","El Agustino","Independencia","Jesús María",
  "La Molina","La Perla","La Punta","Lince","Los Olivos","Magdalena del Mar",
  "Miraflores","Pueblo Libre","Puente Piedra","Rímac","San Borja","San Isidro",
  "San Juan de Lurigancho","San Juan de Miraflores","San Martín de Porres","San Miguel",
  "Santa Anita","Santa Rosa","Santiago de Surco","Surquillo","Ventanilla",
  "Villa El Salvador","Villa María del Triunfo",
].sort((a, b) => a.localeCompare(b, "es"));

const MAX_VISIBLE = 12;

export function CoverageList() {
  const [q, setQ] = useState("");

  const filtered = useMemo(() => {
    const term = q.trim().toLowerCase();
    return term ? ALL_DISTRICTS.filter(d => d.toLowerCase().includes(term)) : ALL_DISTRICTS;
  }, [q]);

  const visible   = filtered.slice(0, MAX_VISIBLE);
  const remaining = Math.max(filtered.length - MAX_VISIBLE, 0);

  return (
    <div>
      {/* Search input */}
      <div className="flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2.5 mb-4">
        <Search className="size-4 text-slate-400 shrink-0" />
        <input
          value={q}
          onChange={e => setQ(e.target.value)}
          placeholder="Buscar distrito..."
          className="w-full bg-transparent text-sm outline-none placeholder:text-slate-400"
        />
        {q && (
          <button onClick={() => setQ("")} aria-label="Limpiar búsqueda">
            <X className="size-4 text-slate-400 hover:text-slate-600" />
          </button>
        )}
      </div>

      {/* Results */}
      {filtered.length === 0 ? (
        <p className="text-sm text-slate-500">
          Distrito no encontrado.{" "}
          <a href={WA_HREF} target="_blank" rel="noopener noreferrer"
            className="font-semibold hover:underline" style={{ color: brand.primary }}>
            Contáctanos
          </a>
        </p>
      ) : (
        <ul className="grid grid-cols-2 gap-2">
          {visible.map(d => (
            <li
              key={d}
              className="flex items-center gap-2 rounded-xl border border-slate-100 bg-white px-3 py-2 text-xs text-slate-600"
            >
              <span className="size-2 rounded-full shrink-0" style={{ background: brand.accentGreen }} />
              {d}
            </li>
          ))}
          {remaining > 0 && (
            <li className="flex items-center gap-2 rounded-xl border border-dashed border-slate-200 px-3 py-2 text-xs text-slate-400">
              +{remaining} distritos más
            </li>
          )}
        </ul>
      )}
    </div>
  );
}